import {Component, computed, inject} from '@angular/core';
import {MessageModule} from 'primeng/message';
import {ProjectBaseStepComponent} from '../../../project-base-step/project-base-step.component';
import {
  ProjectRoleType,
  ProjectStepType,
  SystemRecordingIntegrationControllerService,
} from '@frontend/shared-api';
import {StepDotMenuComponent} from '../../../../../../shared/components/step-dot-menu/step-dot-menu.component';
import {SystemRecordingLegendComponent} from '../shared/components/system-recording-legend/system-recording-legend.component';
import {SystemFlowComponent} from './components/system-flow/system-flow.component';
import {rxResource} from '@angular/core/rxjs-interop';
import {LoadingComponent} from '../../../../../../shared/components/loading/loading.component';
import {AuditInfoComponent} from '../../../../../../shared/components/audit-info/audit-info.component';

@Component({
  imports: [
    MessageModule,
    StepDotMenuComponent,
    SystemRecordingLegendComponent,
    SystemFlowComponent,
    LoadingComponent,
    AuditInfoComponent,
  ],
  templateUrl: './step-3-2-system-flow.component.html',
})
export class Step32SystemFlowComponent extends ProjectBaseStepComponent {
  protected readonly ProjectStepType = ProjectStepType;
  protected readonly ProjectRoleType = ProjectRoleType;

  private readonly systemRecordingIntegrationController = inject(
    SystemRecordingIntegrationControllerService,
  );

  protected readonly integrationSystemRecordingsResource = rxResource({
    params: () => ({projectId: this.projectId}),
    stream: ({params: request}) =>
      this.systemRecordingIntegrationController.getSystemIntegrations1(request),
  });

  protected readonly auditInfo = computed(
    () => this.integrationSystemRecordingsResource.value()?.auditInfo ?? null,
  );
}
